import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showLayout)
      ? (_openBlock(), _createBlock(_component_MainHeader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showLayout)
      ? (_openBlock(), _createBlock(_component_MainSidebar, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast),
    _createElementVNode("div", {
      class: _normalizeClass([
      ' d-flex flex-column transition overflow-hidden full-page',
      { 'main-content': _ctx.showLayout },
    ])
    }, [
      _createVNode(_component_router_view),
      (_ctx.showLayout)
        ? (_openBlock(), _createBlock(_component_MainFooter, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}